// todo need to handle cases like https://siteadmin/users where a normal or admin user has logged in but
// somehow ends up without the site tagged onto the url (in that case we should just redirect to the site in which they logged in)
// also more generally need to handle all the user/non-root admin cases

import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map.js';
import { updateMetadata } from 'pwa-helpers/metadata.js';
import { AppStyles } from '../styles/app-styles';
import { connect } from '../store/connect';
import { store } from '../store/store';
import { configureRouter, configureOpenRouter } from '../routing/router';
import { actions, selectors, constants } from './';
import { actions as accountActions, selectors as accountSelectors } from '../account';
// only for loading templates
import { actions as siteActions, selectors as siteSelectors } from '../site';
import { selectors as userSelectors } from '../user';
import { selectors as routeSelectors } from '../routing';
import { getRouter } from '../routing/route-base';
import { selectors as notificationSelectors } from '../notification';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
const { CAN_EDIT_SITES } = AUTHORIZATIONS;
const { MOBILE_CONSTRAINTS } = constants;
import '@trumedianetworks/tmn-core-components/src/tmn-loading';
import '@trumedianetworks/tmn-core-components/src/tmn-snackbar';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-icon';

// for now, just import all here
import './app-toolbar';
import './app-admin-context';
import './navigation-menu';
import '../site/site-detail';
import '../site/site-list';
import '../site/site-search';
import '../user/user-list';
import '../video-service/package-list';
import '../account/account-login';
import '../account/account-menu';
import '../account/account-reset-password';
import '../routing/routed-link';
import './admin-context-search';
import '../util/loading-logo';
import '../user/user-search-all';
// see here for a few more general layout tips
// https://css-tricks.com/how-to-use-css-grid-for-sticky-headers-and-footers/

class AppMain extends LitElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...AppStyles.styles,
            css`
                @media print {
                    :host {
                        grid-template-rows: 0px minmax(min-content, auto) !important;
                    }
                }
                :host *,
                *:before,
                *:after {
                    box-sizing: border-box;
                }

                :host {
                    display: grid;
                    font-size: 14px;
                    grid-gap: 0;
                    gap: 0;
                    grid-template-columns: auto;
                    grid-template-areas: 'header' 'main' 'footer';
                    grid-template-rows: auto 1fr auto;
                    /* grid-template-rows: 50px minmax(min-content, auto); */
                    height: 100vh;
                }

                main {
                    position: relative;
                    /* child of top level layout*/
                    grid-area: main;
                    /* creates its own layout as well (100vh minus the app bar height*/
                    min-height: calc(100vh - 45px);
                    display: grid;
                    grid-gap: 0;
                    grid-template-columns: auto minmax(0, 1fr);
                    /*40 here is the footer height*/
                    grid-template-rows: auto 40px;
                    grid-template-areas:
                        'side content'
                        'side footer';
                    justify-items: 'start';
                }

                main.login {
                    position: relative;
                    /* child of top level layout*/
                    grid-area: header / main;
                }
                main.login .content {
                    display: flex;
                    margin: auto;
                    padding: 40px;
                    border-radius: 16px;
                    border: 1px solid var(--app-primary-dark-color);
                }

                div[slot='main'] {
                    display: flex;
                    align-items: center;
                }
                .main-nav {
                    display: flex;
                    font-size: 1.1em;
                }
                .main-nav routed-link {
                    padding: 0 8px;
                }
                /* //.main-nav  */

                app-toolbar {
                    padding: 0 10px;
                    grid-area: header;
                    height: 45px;
                }
                /* todo review these for better way to get the scrollbars/height to work right */
                .content {
                    grid-area: content;
                    justify-self: 'stretch';
                    padding: 0 24px;
                    /* this is interesting: we could put a light color
                    behind everything in the content area */
                    background-color: #f8f9fa;
                    --constrained-content-max-width: 1600px;
                    height: 100%;
                    overflow: auto;
                }
                @media (max-width: 1024px) {
                    .content {
                        padding: 0 4px 0 4px;
                    }
                }

                .login .content {
                    height: unset;
                }
                .entity-list {
                    height: calc(100vh - 95px);
                    /* height: calc(100% - 65px); */
                }

                .footer {
                    height: 40px;
                    grid-area: footer;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    justify-self: stretch;
                }
                .footer-item {
                    margin: 10px;
                }

                .search-container {
                    /* margin-left: 64px; */
                    align-items: center;
                    display: flex;
                    justify-content: space-around;
                }

                .main-logo {
                    height: 40px;
                }
                .main-logo-mobile {
                    height: 24px;
                }

                app-admin-context {
                    margin: 0 12px;
                }
                @media (max-width: 500px) {
                    app-admin-context {
                        max-width: 150px;
                    }
                }
            `,
        ];
    }

    static get properties() {
        return {
            title: {
                type: String,
            },
            route: {
                type: String,
            },
            snackbarOpened: {
                type: Boolean,
            },
            snackbarMessage: {
                type: String,
            },
            snackbarType: {
                type: String,
            },
            appCoreLoaded: {
                type: Boolean,
            },
            authorizations: {
                type: Array,
            },
            validUser: {
                type: Boolean,
            },
            activeAuthSite: {
                type: String,
            },
            siteSport: {
                type: String,
            },
            loginToken: {
                type: String,
            },
            accessToken: {
                type: String,
            },
            isMobile: {
                type: Boolean,
            },
        };
    }

    firstUpdated() {
        configureOpenRouter(store);
        this.parseRouteProperties();
        // loginToken here is really old style auth bridge pbtoken
        // accessToken is the new-style auth bridge
        const { loginToken, activeAuthSite, accessToken } = this;
        if (loginToken && activeAuthSite) {
            this.actions.pbtokenLogin(loginToken, activeAuthSite);
        } else if (accessToken && activeAuthSite) {
            this.actions.accessTokenLogin(accessToken, activeAuthSite);
        } else {
            this.actions.fetchUserAccount();
        }
        this.resizeObserver = new ResizeObserver(this.detectMobile.bind(this));
        this.resizeObserver.observe(this.parentElement);
    }

    updated(changedProps) {
        this.updateComplete.then(() => {});
        if (changedProps.has('title')) {
            updateMetadata({
                title: this.title,
                description: this.title,
                // This object also takes an image property, that points to an img src.
            });
        }

        if (changedProps.has('validUser')) {
            if (this.validUser) {
                this.actions.fetchAvailableAuthSites();
                // these need to happen here so the routing can do things that depends on the
                // various templates being loaded. Would prefer to have this in the modules
                if (this.authorizations.includes(CAN_EDIT_SITES)) {
                    this.actions.fetchSiteConfigTemplates();
                }
            }
        }
        if (changedProps.has('appCoreLoaded')) {
            if (this.appCoreLoaded) {
                configureRouter(store);
                this.handleCoreLoaded();
            }
        }
    }

    detectMobile(entries) {
        for (const entry of entries) {
            if (entry.contentBoxSize) {
                const contentBoxSize = entry.contentBoxSize[0];
                const isMobileWidth = contentBoxSize?.inlineSize <= MOBILE_CONSTRAINTS.inlineSize;
                this.actions.updateMobileFlag(isMobileWidth);
            }
        }
    }

    render() {
        const { appCoreLoaded, validUser } = this;
        // try to auto-login user as part of app loading

        if (!validUser) {
            return this.renderLogin();
        }

        if (!appCoreLoaded) {
            return this.renderAppLoading();
        }
        return this.renderAuthorizedApp();
    }

    renderLogin() {
        return html`
            <main role="main" class="login">
                ${this.renderNonAuthorizedRoute()}
                <div class="footer">
                    <div class="footer-item">
                        <a href="http://www.trumedianetworks.com/terms-of-use" target="_blank"
                            >Terms of use</a
                        >
                        &copy; TruMedia Networks ${new Date().getFullYear()}
                    </div>
                </div>
            </main>
            ${this.renderSnackBar()}
        `;
    }

    renderNonAuthorizedRoute() {
        const { route } = this;
        switch (route) {
            case 'reset-password':
            case 'reset-password-site':
                return html`<account-reset-password class="content"> </account-reset-password>`;
            default:
                return html`<account-login class="content"> </account-login>`;
        }
    }

    renderMainLogo() {
        const { isMobile } = this;
        return isMobile
            ? html`<img
                  src="/assets/images/tmn-mobile.png"
                  alt="TruMedia Networks"
                  class="main-logo-mobile" />`
            : html`<img
                  src="/assets/images/trumedia_networks.svg"
                  alt="TruMedia Networks"
                  class="main-logo" />`;
    }

    renderAppTeamLogo() {
        return null;
    }

    renderAppLoading() {
        return html`<loading-logo .isLoading=${true}></loading-logo> `;
    }

    handleCoreLoaded() {
        this.setLandingRoute();
    }

    setLandingRoute() {
        // kind of a hack, maybe revisit in the routing section?
        // i think it's ok for now to re-route here, it ensures we're loaded
        // without over-complicating the routing.. we can review though
        const { route, authorizations, siteSport, activeAuthSite } = this;
        const canEditSites = authorizations.includes(CAN_EDIT_SITES);
        if (route === 'home') {
            const adjustedRoute = canEditSites ? 'site-list' : 'user-list';
            const router = getRouter();
            const routeData = canEditSites ? { sport: siteSport } : { authSite: activeAuthSite };
            router.navigateByName(adjustedRoute, routeData);
        }
    }

    renderAuthorizedRoute() {
        // seem tmn-page-router in ferp-ui if we want to move this out and load components dynamically
        const { route, isMobile } = this;
        switch (route) {
            case 'site-list':
            case 'site-detail':
            case 'child-site-list':
            case 'child-site-detail':
            case 'child-site-new':
            case 'site-new':
                return html`<site-list class="entity-list"></site-list>`;
            case 'user-list':
            case 'user-landing':
            case 'user-detail':
            case 'user-new':
                return html`<user-list class="entity-list" .isMobile=${isMobile}></user-list>`;
            case 'video-service-list':
            case 'video-service-detail':
                return html`<package-list .isMobile=${isMobile}></package-list>`;
            case 'auth-site-list':
                return html`<admin-context-search></admin-context-search>`;
            case 'user-search-all':
                return html`<user-search-all></user-search-all>`;
            case 'home':
            case 'overview':
            default:
                // todo could just be list here as well for now
                return html`<div>Page not found</div>`;
        }
    }

    renderSnackBar() {
        return html`<tmn-snackbar ?active=${this.snackbarOpened} type=${this.snackbarType}>
            ${this.snackbarMessage}
        </tmn-snackbar>`;
    }

    renderAuthorizedApp() {
        return html`
            <app-toolbar top-level>
                <div slot="main">
                    <a slot="startLogo" href="/" rel="external" class="navbar-logo"
                        >${this.renderMainLogo()}</a
                    >
                    <app-admin-context></app-admin-context>
                </div>
                <div slot="navigation">${this.renderMainNavigation()}</div>
                <div slot="right-menus">
                    <account-menu></account-menu>
                </div>
            </app-toolbar>
            <main role="main">
                <div class="content">${this.renderAuthorizedRoute()}</div>
                <div class="footer">
                    <div class="footer-item">
                        <a href="http://www.trumedianetworks.com/terms-of-use" target="_blank"
                            >Terms of use</a
                        >
                        &copy; TruMedia Networks ${new Date().getFullYear()}
                    </div>
                </div>
            </main>
            ${this.renderSnackBar()}
        `;
    }

    renderMainNavigation() {
        return html`<navigation-menu></navigation-menu>`;
    }

    parseRouteProperties() {
        const url = new URL(location.href);
        this.loginToken = url.searchParams.get('pbtoken');
        this.accessToken = url.searchParams.get('access_token');
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        return {
            title: 'Trumedia Site Admin',
            appCoreLoaded: selectors.appCoreLoadedSelector(state),
            isMobile: selectors.isMobile(state),
            snackbarOpened: notificationSelectors.snackbarOpenedSelector(state),
            snackbarMessage: notificationSelectors.snackbarMessageSelector(state),
            snackbarType: notificationSelectors.snackbarTypeSelector(state),
            route: routeSelectors.currentRouteName(state),
            validUser: accountSelectors.isValidUser(state),
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
            activeAuthSite: userSelectors.activeAuthSiteNameSelector(state),
            siteSport: siteSelectors.siteSportSelector(state),
        };
    };
};

const fetchActions = {
    fetchSiteConfigTemplates: siteActions.fetchSiteConfigTemplates,
    //fetchUserConfigTemplates: userActions.fetchUserConfigTemplates,
};

const combinedActions = {
    ...fetchActions,
    ...actions,
    ...accountActions,
};

customElements.define('app-main', connect(mapStateToProps, combinedActions)(AppMain));
